module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3qsWD"))).then(() => parcelRequire('iDabs'));